import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Box, Button, Text } from "pcln-design-system";
const RealTimeVoiceModalInfo = ({ onContinue })=>/*#__PURE__*/ jsxs(Box, {
        padding: 3,
        children: [
            /*#__PURE__*/ jsx(Text, {
                color: "text.heading",
                fontSize: '26px',
                lineHeight: '32px',
                fontWeight: "bold",
                children: "Penny Voice. Now with real-time, natural conversations."
            }),
            /*#__PURE__*/ jsx(Text, {
                mt: 4,
                fontSize: 1,
                children: "Searching for hotels or updating your travel plans is now easier than ever with Penny Voice."
            }),
            /*#__PURE__*/ jsxs(Text, {
                mt: 4,
                fontSize: 1,
                children: [
                    ' ',
                    "Enjoy real-time responses, the ability to interrupt anytime, and smooth, personalized interactions that adapt to your needs.",
                    ' '
                ]
            }),
            /*#__PURE__*/ jsxs(Text, {
                mt: 4,
                fontSize: 1,
                children: [
                    ' ',
                    "Ready to experience the future of travel assistance? Try Penny Voice today and see how effortless and fun travel planning can be!"
                ]
            }),
            /*#__PURE__*/ jsx(Button, {
                width: 1,
                mt: 4,
                onClick: onContinue,
                children: "Continue"
            })
        ]
    });
const Voice_RealTimeVoiceModalInfo = RealTimeVoiceModalInfo;
export { Voice_RealTimeVoiceModalInfo as default };
